module.exports = __webpack_public_path__ + "static/media/mercado-modelo-logo-branding.1ef31ac5.jpg";